import React from 'react';

import Link from './Link';

import './Terms.css';

interface Props {
  additionalClasses?: string;
}

const Terms: React.FC<Props> = props => {
  const { additionalClasses } = props;

  return (
    <div className={`ui-terms ui-text-color-gray ${additionalClasses}`}>
      FlexFactor <Link href="https://www.flexfactor.io/end-user-terms-of-service">End User Agreement</Link> and{' '}
      <Link href="https://www.flexfactor.io/privacy-policy">Privacy Policy</Link>.
    </div>
  );
};

export default Terms;
